import { useMemo } from 'react';
import { useAuthStore } from '@/store/authStore';

/** Permission checks for CSPM action buttons (route still gates cspm.view). */
export function useCspmPermissions() {
  const user = useAuthStore((s) => s.user);
  return useMemo(() => {
    const perms = user?.permissions ?? [];
    const isSuper = Boolean(user?.is_super_admin);
    const can = (...codes: string[]) =>
      isSuper || codes.some((c) => perms.includes(c));
    return {
      canView: can('cspm.view'),
      canRequirementCreate: can('cspm.requirement.create'),
      canRequirementEdit: can('cspm.requirement.edit'),
      canReceiptCreate: can('cspm.receipt.create'),
      canReceiptEdit: can('cspm.receipt.edit'),
      canReceiptPost: can('cspm.receipt.post'),
      canInspect: can('cspm.inspect'),
      canAllocate: can('cspm.allocate'),
      canTransfer: can('cspm.allocation.transfer', 'cspm.allocate'),
      canExceptionCreate: can('cspm.exception.create'),
      canDisposition: can('cspm.disposition.authorize', 'cspm.exception.create'),
      canReturn: can('cspm.return_customer'),
      canReconcile: can('cspm.reconcile'),
      canPortalIssue: can('cspm.portal.issue'),
      canAdvisoryView: can('cspm.advisory.view'),
    };
  }, [user?.permissions, user?.is_super_admin]);
}
